import {
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  Group,
} from '@mui/icons-material';
import { Box, Collapse, Tooltip } from '@mui/material';
import React from 'react';
import InvestmentEntityContact from '../../models/InvestmentEntityContact';
import { StyledIconButton } from '../styles/StyledButtons';
import { StyledCard, StyledCardContent, StyledHeading, StyledTypography } from '../styles/styles';
import { EntityManagementContactCard } from './EntityManagementContactCard';

interface EntityManagementContactsSectionProps {
  contacts: InvestmentEntityContact[];
  expanded: boolean;
  showContactAssociation: boolean;
  onToggleExpanded: () => void;
  onManageContacts: () => void;
  onPromoteToOwner: (contactId: string) => void;
}

export const EntityManagementContactsSection: React.FC<EntityManagementContactsSectionProps> = ({
  contacts,
  expanded,
  showContactAssociation,
  onToggleExpanded,
  onManageContacts,
  onPromoteToOwner,
}) => (
  <StyledCard tone="default" sx={{ mb: 3 }}>
    <StyledCardContent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <StyledHeading tone="default" headerVariant="heading2">
          Associated Contacts
        </StyledHeading>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Tooltip title={expanded ? 'Hide Contacts' : 'Show Contacts'}>
            <StyledIconButton size="small" onClick={onToggleExpanded}>
              {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </StyledIconButton>
          </Tooltip>
          <Tooltip
            title={showContactAssociation ? 'Hide Contact Management' : 'Add/Remove Contacts'}
          >
            <StyledIconButton size="small" onClick={onManageContacts}>
              <Group />
            </StyledIconButton>
          </Tooltip>
        </Box>
      </Box>

      <Collapse in={expanded}>
        {contacts.length > 0 ? (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
            {contacts.map((contact) => (
              <EntityManagementContactCard
                key={contact.id}
                contact={contact}
                onPromoteToOwner={onPromoteToOwner}
              />
            ))}
          </Box>
        ) : (
          <StyledTypography sx={{ py: 2, textAlign: 'center', color: 'text.secondary' }}>
            No contacts associated with this entity
          </StyledTypography>
        )}
      </Collapse>
    </StyledCardContent>
  </StyledCard>
);
